import { InterestCalculationResponse } from "@/models/interestCalculation/interestCalculationResponse";
import envSettings from "@/services/system/envSettings";
import { createEntityAdapter } from "@reduxjs/toolkit";
import { delay, http, HttpResponse } from "msw";
import { SetupServer } from "msw/node";
import { getInterestCalculatorSet } from "../sets/interestCalculatorSet";
import { infrastructureHandlers } from "./infrastructureHandlers";

const interestCalculatorAdapter = createEntityAdapter({
  selectId: (item: InterestCalculationResponse) => item.balanceToDate,
});
let interestCalculatorState = interestCalculatorAdapter.getInitialState();
interestCalculatorState = interestCalculatorAdapter.setOne(interestCalculatorState, getInterestCalculatorSet);

const url = `${envSettings.FILTER_API_URL}/${envSettings.GET_INTEREST_CALCULATION_PREF}`;

export const interestCalculatorHandler = [
  http.get(url, async () => {
    await delay(150);
    return HttpResponse.json(Object.values(interestCalculatorState.entities)[0], { status: 200 });
  }),
];

export const errorStatusInterestCalculatorHandler = http.get(url, () => {
  return HttpResponse.json({ message: "Internal server error" }, { status: 500 });
});

export const faultyInterestCalculatorHandler = http.get(url, () => {
  return HttpResponse.json({ weirdDataType: "Something went wrong" }, { status: 200 });
});

export const setupInterestCalculatorHandler = (server: SetupServer) => {
  server.use(...interestCalculatorHandler, ...infrastructureHandlers);
};

export const setupErrorStatusInterestCalculatorHandler = (server: SetupServer) => {
  server.use(errorStatusInterestCalculatorHandler);
};

export const setupFaultyInterestCalculatorHandler = (server: SetupServer) => {
  server.use(faultyInterestCalculatorHandler);
};
